import React from "react";
import { Chip, makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => {
  return {
    active: {
      backgroundColor: theme.palette.green.main,
    },
    used: {
      backgroundColor: theme.palette.primary.dark,
    },
    expired: {
      backgroundColor: theme.palette.grey[500],
    },
    revoked: {
      backgroundColor: theme.palette.error.main,
    },
    label: {
      color: theme.palette.common.white,
      fontWeight: theme.typography.fontWeightBold,
    },
  };
});

const STATUS_LABEL = {
  ACTIVE: "app.invite.status.active",
  USED: "app.invite.status.used",
  EXPIRED: "app.invite.status.expired",
  REVOKED: "app.invite.status.revoked",
};

const STATUS_CLASS = {
  ACTIVE: "active",
  USED: "used",
  EXPIRED: "expired",
  REVOKED: "revoked",
};

const InviteStatusBadge = ({ status }) => {
  const classes = useStyles();
  const statusClass = STATUS_CLASS[status] || STATUS_CLASS.ACTIVE;

  return (
    <Chip
      size="small"
      label={<FormattedMessage id={STATUS_LABEL[status] || STATUS_LABEL.ACTIVE} />}
      className={classes[statusClass]}
      classes={{ label: classes.label }}
    />
  );
};

export default InviteStatusBadge;
